module.exports = __webpack_public_path__ + "img/35.0e8081b6.svg";